import { HelpText } from '@/components/helpText';
import { Card } from '@/components/ui/smallCard';
import { FormattedMessage } from 'react-intl';

export function AboutContent() {
  return (
    <div>
      <div className="g-prose g-text-sm [&_h3]:g-m-0 [&_h3]:g-text-sm">
        <HelpText identifier={'what-is-a-dataset'} includeTitle />
      </div>
    </div>
  );
}

export function ApiContent() {
  return (
    <div className="g-text-sm g-prose">
      <div className="g-prose g-text-sm [&_h3]:g-m-0 [&_h3]:g-text-sm">
        <HelpText identifier={'api-access'} includeTitle />
      </div>
      <h4>
        <FormattedMessage id="apiHelp.examples" />
      </h4>
      <Card className="g-p-2 g-mb-2">
        <FormattedMessage id="apiHelp.searchDatasets" /> <br />
        <a
          href={`${import.meta.env.PUBLIC_API}/v1/dataset/search`}
        >{`${import.meta.env.PUBLIC_API}/v1/dataset/search`}</a>
      </Card>
      <Card className="g-p-2">
        <FormattedMessage id="apiHelp.searchDatasetsExample" /> <br />
        <br />
        <a
          href={`${import.meta.env.PUBLIC_API}/v1/dataset/search?q=fungi&publishingCountry=DK&limit=2&offset=0`}
        >
          {`${import.meta.env.PUBLIC_API}/v1/dataset/search?q=fungi&publishingCountry=DK&limit=2&offset=0`}
        </a>
      </Card>
    </div>
  );
}
